exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.vue-daterange-picker {\n  width: 100%;\n}\n.vue-daterange-picker .reportrange-text {\n  padding: 9px 10px;\n}\n", ""]);

